<template>
  <div
    :class="[
      `m-detail-list`,
    ]"
  >
    <h3 v-if="title" class="h4">{{ title }}</h3>
    <dl class="m-detail-list__field p">
      <template
        v-for="(definition, term, index) in items"
      >
        <dt
          :key="`dt-${index}`"

          class="m-detail-list__title fw-bold"

          v-html="term"
        />
        <dd
          :key="`dd-${index}`"

          class="m-detail-list__detail"

          v-html="definition || `…`"
        />
      </template>
    </dl>
  </div>
</template>

<script>
export default {
  name: `module-detail-list`,

  // Props
  props: {
    title: {
      type: String,
    },
    items: {
      type: Object,
    },
  },
};
</script>



// WEBPACK FOOTER //
// DetailList.vue?12d86890